<template>
    <div class="sportFootballMatchActionIconCategory">
      <svgicon :name="icon" original />
      <svgicon v-if="chance" name="sport/football/match/scoringchance" original />
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionIconCategory',
  props: {
    action: Object
  },
  computed: {
    icon () { return 'sport/football/match/' + this.action.category?.icon },
    chance () { return this.action.chance && this.action.typeId !== 10 }
  }
}
</script>

<style>
.sportFootballMatchActionIconCategory {
  grid-area: icon
}
.sportFootballMatchActionIconCategory svg {
  width:25px;
  height:25px
}
</style>
